
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PublicitySection from './components/PublicitySection';
import ShowcaseSection from './components/ShowcaseSection';
import ClientsSection from './components/ClientsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import { SEO, generateOrganizationSchema, generateWebSiteSchema, generateServiceSchema } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";
  
  const jsonLdSchemas = [
    generateOrganizationSchema(),
    generateWebSiteSchema(),
    generateServiceSchema()
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Castle & Castle Marketing Agency - Building Brands, Brick by Brick"
        description="Full-stack growth marketing agency specializing in data-driven growth operations. Expert services in SEO, PR, influencer marketing, paid ads, and more."
        keywords="marketing agency, growth marketing, SEO, PR, influencer marketing, paid advertising, brand building, digital marketing"
        canonical={`${siteUrl}/`}
        ogTitle="Castle & Castle Marketing Agency - Building Brands, Brick by Brick"
        ogDescription="Full-stack growth marketing agency specializing in data-driven growth operations. Expert services in SEO, PR, influencer marketing, paid ads, and more."
        ogImage="https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/e8a8ca3e4b8833280e8b49a553477781.png"
        ogUrl={`${siteUrl}/`}
        twitterTitle="Castle & Castle Marketing Agency - Building Brands, Brick by Brick"
        twitterDescription="Full-stack growth marketing agency specializing in data-driven growth operations. Expert services in SEO, PR, influencer marketing, paid ads, and more."
        twitterImage="https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/e8a8ca3e4b8833280e8b49a553477781.png"
        jsonLd={jsonLdSchemas}
      />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <PublicitySection />
        <ShowcaseSection />
        <ClientsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
